<template>
  <i-spin v-if="loading" fix>
    <i-icon type="ios-loading" size="40" class="spin-icon-load" />
  </i-spin>
  <div v-else-if="hasDefault && !bindNew" class="send-bind-card">
    <p class="title">Your default payment method</p>
    <div class="card">
      <img src="../../../assets/imgs/credit-card.png" class="card-icon" alt="" />
      <div style="padding-right: 40px;">
        <p class="card-title">Credit Card</p>
        <p class="card-text">•••• {{ defaultCardNumber }}</p>
      </div>
      <div>
        <i-button type="text" ghost class="change-button" @click="bindNew = true">Change</i-button>
      </div>
    </div>
    <p class="terms">
      By providing your credit card details and agreeing to the
      <router-link class="route" to="/">Terms of Pay</router-link>, you authorize us to charge your credit card for the
      relevant service fees after the package has been inbounded. For example, shipping and storage fee.
    </p>
    <Button class="confirm" @click="orderUseDefaultCard()">
      <span><i-icon type="ios-lock" />Confirm</span>
    </Button>
  </div>
  <div v-else class="send-bind-card">
    <div style="display:flex; justify-content: space-between">
      <p class="title">Add a payment method</p>
      <i-button v-if="hasDefault" type="text" class="change-button" @click="bindNew = false">Use saved card</i-button>
    </div>
    <StripeBindCard
      ref="stripeBindCard"
      @change-loading="$emit('change-loading', $event)"
      @bind-success="$emit('bind-success')"
    />
    <p class="terms">
      By providing your credit card details and agreeing to the
      <router-link class="route" to="/">Terms of Pay</router-link>, you authorize us to charge your credit card for the
      relevant service fees after the package has been inbounded. For example, shipping and storage fee.
    </p>
    <!--    <div style="background:#eee;padding: 20px; margin-top: 30px">-->
    <!--      <i-check-box v-model="isDefault">-->
    <!--        Save as default card-->
    <!--      </i-check-box>-->
    <!--      <p style="color: #666666;font-size: 11px; margin-top: 5px; margin-left: 25px">-->
    <!--        You can securely store credit card details to create new orders faster next time-->
    <!--      </p>-->
    <!--    </div>-->
    <Button class="confirm" @click="$refs.stripeBindCard.confirmPayment(isDefault)">
      <span><i-icon type="ios-lock" />Confirm</span>
    </Button>
  </div>
</template>

<script>
import Button from '../../../components/button/Button';
import StripeBindCard from '../../../components/stripe/StripeBindCard';
import { API } from '../../../net/http';
export default {
  components: {
    StripeBindCard,
    Button,
  },
  data() {
    return {
      loading: true,
      isDefault: false,
      orderNum: this.$route.params.orderNumber,
      hasDefault: false,
      bindNew: false,
      defaultCardNumber: '',
    };
  },
  mounted() {
    this.fetchPaymentMethod();
  },
  methods: {
    fetchPaymentMethod() {
      this.$post(API.fetchPaymentMethod).then(res => {
        if (!res.success) return;
        const data = res.data;
        this.defaultCardNumber = data.cardNumber;
        if (this.defaultCardNumber) {
          console.log('hasDefaultCard');
          this.hasDefault = true;
        } else {
          console.log('noDefaultCard');
          this.hasDefault = false;
        }
        this.loading = false;
      });
    },
    orderUseDefaultCard() {
      this.$post(API.orderUseDefaultCard, this.orderNum).then(res => {
        console.log('bind-success-emit res.success', res.success);
        if (!res.success) return;
        this.$emit('bind-success');
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/main.less';
@import '../../../assets/fonts/font.less';
.send-bind-card {
  .title {
    .font-regular;
    font-size: 20px;
    font-weight: 400;
    color: @app-color;
  }
  .terms {
    .font-light;
    margin-top: 26px;
    font-size: 12px;
    font-weight: 300;
    color: @app-black-color;
    .route {
      color: @app-blue-color;
      padding-left: 6px;
    }
  }
  .confirm {
    width: 146px;
    margin: 36px auto 0;
  }
}
.change-button {
  color: @app-blue-color;
}
.card {
  .font-regular;
  background-color: #fbfbfb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  height: 66px;
  margin-top: 30px;

  .card-icon {
    width: 40px;
    height: 40px;
    margin: 0 20px;
  }
  .card-title {
    color: #333333;
    font-size: 15px;
  }
  .card-text {
    color: #333333;
    font-size: 12px;
  }
}
</style>
